import { render, staticRenderFns } from "./UpdateOrgalias.vue?vue&type=template&id=777f6849&scoped=true"
import script from "./UpdateOrgalias.vue?vue&type=script&lang=js"
export * from "./UpdateOrgalias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777f6849",
  null
  
)

export default component.exports